import { FC } from 'react';
import { Heading, Types } from '@marriott/mi-ui-library';
import { EventBookingDetailsProps } from './EventBookingDetails.types';
import { StyledEventBookingDetails, StyledTable } from './EventBookingDetails.styles';
import { AvailabilityDetails, RateDetail } from '@marriott/mi-groups-graphql';
import { formatAmount, getFormattedDateString } from '../../../../../utils';
import { getBaseRate } from '../../../../utils/reslink';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EventBookingDetails: FC<EventBookingDetailsProps> = (props: any) => {
  const { bookingStatsLabels, bookingStatsData, groupRatesLabels, groupRatesData, showGroupRates = true } = props;
  const { heading: bookingStatsHeading, date, percentPickedUp, totalPickedUp, totals } = bookingStatsLabels;
  const { heading: groupRatesHeading, roomType, perNight } = groupRatesLabels;

  return (
    <StyledEventBookingDetails className="my-5 container">
      <div className="row p-5 mb-5 shell">
        <div className="col-12">
          <Heading
            fontSize={Types.size.small}
            titleText={bookingStatsHeading}
            variation={Types.headingType.title}
            element={Types.tags.h2}
          />
        </div>
        <div className="col-12 px-5 event-bookings">
          <StyledTable>
            <caption className="sr-only">{bookingStatsHeading}</caption>
            <thead>
              <tr>
                <th>{date}</th>
                <th>{totalPickedUp}</th>
                <th>{percentPickedUp}</th>
              </tr>
            </thead>
            <tbody>
              {bookingStatsData?.availabilityList?.map((availabilityDetails: AvailabilityDetails, index: number) => (
                <tr key={index}>
                  <td>{getFormattedDateString(availabilityDetails?.startDate as string, 'dateWithDayMonthAndYear')}</td>
                  <td>
                    {availabilityDetails.sold} <span className="t-font-s">/ {availabilityDetails.authorized}</span>
                  </td>
                  <td>
                    {availabilityDetails.percentageOfRoomsSold}
                    <span className="t-font-s">%</span>
                  </td>
                </tr>
              ))}
              <tr>
                <td>{totals}</td>
                <td>
                  {bookingStatsData?.totalSold} <span className="t-font-s">/ {bookingStatsData?.totalRooms}</span>
                </td>
                <td>
                  {bookingStatsData?.percentageOfRoomsSold}
                  <span className="t-font-s">%</span>
                </td>
              </tr>
            </tbody>
          </StyledTable>
        </div>
      </div>
      {showGroupRates && (
        <div className="row p-5 shell">
          <div className="col-12">
            <Heading
              fontSize={Types.size.extraSmall}
              titleText={groupRatesHeading}
              variation={Types.headingType.title}
              element={Types.tags.h3}
            />
          </div>
          <div className="col-12 px-5 group-rates">
            <StyledTable>
              <caption className="sr-only">{groupRatesHeading}</caption>
              <thead className="sr-only">
                <tr>
                  <th>{roomType}</th>
                  <th>{perNight}</th>
                </tr>
              </thead>
              <tbody>
                {groupRatesData?.map((rate: RateDetail, index: number) => (
                  <tr key={index}>
                    <td>{rate?.roomTypeDetail?.description}</td>
                    <td>
                      {formatAmount(+getBaseRate(rate.rateAmounts).rateValue)}
                      <span className="t-font-s">
                        {' '}
                        {rate?.rateAmounts?.[0]?.amount?.currency}
                        {perNight}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </StyledTable>
          </div>
        </div>
      )}
    </StyledEventBookingDetails>
  );
};
